import React, {Component} from 'react'
import * as THREE from "three"
import {map_range} from './HandyMaths'


class LALVideoView  extends Component {

	video: HTMLElement
	vs: HTMLElement
	videoCanvas: HTMLElement
	videoCanvasCtx: CanvasRenderingContext2D
	texture: THREE.Texture
	mesh: THREE.Mesh
	material: THREE.MeshBasicMaterial
	
	
	fmx = 1
	fmy = 1
	
	level = -90
	delta = 0

	constructor(
		scene: THREE.Scene,
		videoFile: string,
		onLoaded: () => void,

		){

		super()
		
		// VIDEO

    //video to canvas
    this.videoCanvas = document.createElement('canvas')
    this.videoCanvasCtx = this.videoCanvas.getContext('2d')

		this.video = document.createElement('video')

		this.video.src = videoFile
		this.video.setAttribute('preload', "auto")
		this.video.muted = true
		this.video.loop = true
		this.video.setAttribute('playsInLine', true)


		console.log(this.video)
		
		this.video.load()
	
		this.video.oncanplay = (e) => {

			console.log(e)
			// this.video.playbackRate = 2
			this.video.play()

			this.videoCanvas.width = this.video.videoWidth
			this.videoCanvas.height = this.video.videoHeight
	

			console.log("video " + videoFile + " loaded")

			onLoaded()
			this.video.oncanplay = null

    }

		// this.videoCanvasCtx.fillStyle = "blue"
		// this.videoCanvasCtx.fillRect(0,0,1920,1080)

		// TEXTURE
		//canvas to texture
		this.texture = new THREE.Texture(this.videoCanvas)
		this.texture.minFilter = THREE.NearestFilter

		// GEOMETRY
		var geometry = new THREE.PlaneBufferGeometry(4,3)

		// MATERIAL
		this.material = new THREE.MeshBasicMaterial( { map: this.texture} )
		this.material.transparent = true
		this.material.opacity = 0.5
		this.mesh = new THREE.Mesh( geometry, this.material )
	

		scene.add(this.mesh)
	}
	
	animate(now: number, val: int){
		
		let normX = 0.5//this.props.activePosition.x / window.innerWidth
		let normY = 0.5//this.props.activePosition.y / window.innerHeight

		if(this.props !== undefined){
			normX = this.props.activePosition.x / window.innerWidth
			normY = this.props.activePosition.y / window.innerHeight
	
		}
		this.fmx += (normX - this.fmx) * 0.09;
		this.fmy += (normY - this.fmy) * 0.09;

//		this.material.opacity = map_range(val, -30.0, -0.0, 0.4, 1.0)

		let div = (map_range(this.fmy, 0.0, 1.0, 50.0, 1.0))
		let stepW = (this.videoCanvas.width / div);
		let destW = 1- map_range(this.fmx, 0.0, 1.0, 0.01, 0.6)
		let trans = map_range(this.fmx, 0.0, 1.0, 0.5, 1)

		// this.mesh.position.set(val,0,0)
		// this.material.opacity = map_range(this.level, -30.0, -0.0, 0.5, 1.0)

		if(this.video.readyState === this.video.HAVE_ENOUGH_DATA){
			//void ctx.drawImage(image, sx, sy, sWidth, sHeight, dx, dy, dWçidth, dHeight);
			this.videoCanvasCtx.fillStyle = "black"
			this.videoCanvasCtx.fillRect(0,0,1920,1080)


			this.videoCanvasCtx.drawImage(this.video,
				0,
				0,
				this.videoCanvas.width,
				this.videoCanvas.height,
				0,
				0,
				this.videoCanvas.width,
				this.videoCanvas.height
			)

			this.videoCanvasCtx.fillStyle = 'rgba(0, 0, 0, '+trans+')'
			
			this.delta += Math.PI / 100

			if(this.delta > Math.PI * 2){
				this.delta -= Math.PI * 2
			}

			let da = 0.8 + Math.sin(this.delta) * 0.4

			for(var i=0; i<div; i++){

				this.videoCanvasCtx.fillRect(
					stepW * i, 
					0, 
					stepW * destW * da, 
					this.videoCanvas.height
					)

			}

			this.texture.needsUpdate = true
		}      
		
	}
	render() {
	return <div></div>
	}
} 


export default LALVideoView